// Shared day/night utilities for both desktop and mobile

export const parseTimeString = (timeStr, date) => {
  // Parse time strings like "6:20:35 AM" or "8:21:32 PM"
  const [time, period] = timeStr.split(' ');
  const [hours, minutes, seconds] = time.split(':').map(Number);
  
  let hour24 = hours;
  if (period === 'PM' && hours !== 12) {
    hour24 += 12;
  } else if (period === 'AM' && hours === 12) {
    hour24 = 0;
  }
  
  const resultDate = new Date(date);
  resultDate.setHours(hour24, minutes, seconds, 0);
  return resultDate;
};

export const checkDayTime = async (setIsDay, setLoading) => {
  try {
    const response = await fetch(`https://api.sunrisesunset.io/json?lat=40.71427&lng=-74.00597`);
    const data = await response.json();
    const dateData = data.results;
    
    // Get current time
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    
    // Parse dawn and last_light times
    const dawnTime = parseTimeString(dateData.dawn, today);
    const lastLightTime = parseTimeString(dateData.last_light, today);
    
    // Check if current time is after dawn but before last light
    const isDayTime = now >= dawnTime && now < lastLightTime;
    
    setIsDay(isDayTime);
    if (setLoading) setLoading(false);
    
  } catch (error) {
    console.error('Error fetching sunrise/sunset data:', error);
    // Fallback to simple time-based check if API fails
    const currentHour = new Date().getHours();
    setIsDay(currentHour >= 6 && currentHour < 18);
    if (setLoading) setLoading(false);
  }
};

